import React from 'react';
import CareersFooter from '../components/CareersComponents/CareersFooter'; 
import InternshipHero from '../components/CareersComponents/Internship/InternshipHero';
import JobOpeningLayout from '../components/CareersComponents/JobOpeningComponents/JobOpeningLayout';

const Internship = () => (
  <>
    <InternshipHero />
    <JobOpeningLayout defaultTypes={['Internship']} fromInternship={true} />
    <CareersFooter />
  </>
);

export default Internship;
